import React from 'react';

const SignIn: React.FC = () => {
  return (
    <div className="p-4">
      <h2 className="text-white text-lg font-medium mb-4">Sign In</h2>
      <p className="text-gray-300">Sign in functionality would be implemented here.</p>
    </div>
  );
};

export default SignIn;
